const COUNTRY_CODE = '57'

/** Enlace a un chat de WhatsApp para un número local colombiano, sin mensaje predefinido. */
export function whatsAppChatUrl(phoneNumber: string, message?: string): string {
  const digits = phoneNumber.replace(/\D/g, '')
  const query = message ? `?text=${encodeURIComponent(message)}` : ''
  return `https://wa.me/${COUNTRY_CODE}${digits}${query}`
}

export type PricingKind = 'wholesale' | 'retail'

export interface InquiryLine {
  name: string
  quantity?: number
  url: string
}

function formatInquiryLine(item: InquiryLine): string {
  const suffix = item.quantity && item.quantity > 1 ? ` x${item.quantity}` : ''
  return `${item.name}${suffix}\n${item.url}`
}

/** Arma el mensaje de consulta por WhatsApp (uno o varios productos), diferenciando precio al por mayor vs. al detal. */
export function buildInquiryMessage(kind: PricingKind, items: InquiryLine[]): string {
  const plural = items.length > 1
  const intro =
    kind === 'wholesale'
      ? `Hola! Estoy interesada en el precio al por mayor y los requisitos para ${plural ? 'estos productos' : 'este producto'}:`
      : `Hola! Me interesa${plural ? 'n estos productos' : ' este producto'}:`
  const lines = items.map(formatInquiryLine).join('\n\n')
  return `${intro}\n\n${lines}`
}
